import { Router } from './router';
import { DependencyContainerFactory } from './dependencyContainerFactory';
import {getRegistry} from "./core/Registry";

export class RenderComponent {
    private readonly router: Router;

    constructor(router: Router) {
        this.router = router;
    }

    private capitalize(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    private getLastSegment(path: string): string {
        const parts = path.split('/');
        return parts[parts.length - 1];
    }

    async render<TPresenter>(routeName: string, tagName: string = 'div') {
        const registry = getRegistry();

        const parts = routeName.split('/').filter(p => p.length > 0);
        const parentParts = parts.slice(0, -1);
        const lastPart = parts[parts.length - 1];
        const filePath = parentParts.length > 0 ? `${parentParts.join('/')}/${lastPart}` : lastPart;
        const className = this.capitalize(lastPart);

        const viewPath = `${filePath}/${lastPart}View`;
        const presenterPath = `${filePath}/${lastPart}Presenter`;
        const templatePath = `${filePath}/${lastPart}View.html`;

        const ViewClass = await registry.getView(viewPath);
        const PresenterClass = await registry.getPresenter(presenterPath);
        const fragment = await registry.getTemplate(templatePath);

        const componentElement = document.createElement(tagName);
        componentElement.innerHTML = fragment;

        const dependencyContainer = DependencyContainerFactory.create(this.router);

        const view = new ViewClass(lastPart, this.router, dependencyContainer);
        const presenter = new PresenterClass(view, this.router, dependencyContainer);

        view.setPresenter(presenter);
        view.setElement(componentElement);

        await view.render();

        if (!view.$element) throw new Error('View $element is not defined.');
        if (!view._presenter) throw new Error('View has an undefined Presenter.');

        return presenter;
    }
}
